import React, { useContext, useState, useEffect } from "react";
import "./ProjectAuthorization.css";
import ProjectAuthTable from "./components/ProjectAuthTable";
import { useLanguage } from "../../../../LanguageProvider";
import UserSearchInput from "./components/UserSearchInput";
import Dropdown from "../../../../components/Dropdown/Dropdown";
import { TbDeviceFloppy } from "react-icons/tb";
import { GeneralContext } from "../../../../GeneralProvider";
import ProjectUserTable from "./components/ProjectUserTable";

const ProjectAuthorization = ({ users: initialUsers }) => {
  const { getTranslation } = useLanguage();
  const { collections, panels, userId } = useContext(GeneralContext);

  const [users, setUsers] = useState(initialUsers);
  const [filteredUsers, setFilteredUsers] = useState(initialUsers);
  const [selectedModule, setSelectedModule] = useState("");
  const [subModuleOptions, setSubModuleOptions] = useState([]);
  const [selectedSubModule, setSelectedSubModule] = useState("");

  useEffect(() => {
    setUsers(initialUsers);
    setFilteredUsers(initialUsers); // Component güncellendiğinde filtrelenmiş kullanıcıları sıfırla
  }, [initialUsers]);

  const handlePermissionChange = (userIndex, permissionType) => {
    setFilteredUsers((prevUsers) =>
      prevUsers.map((user, index) => {
        if (index === userIndex) {
          return {
            ...user,
            read: permissionType === "read",
            write: permissionType === "write",
            access: permissionType === "all",
          };
        }
        return user;
      })
    );
  };

  const handleSearch = (searchValue) => {
    if (!searchValue) {
      setFilteredUsers(users); // Eğer arama boşsa tüm kullanıcıları geri getir
    } else {
      const filtered = users.filter((user) =>
        `${user.name} ${user.lastname}`
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      );
      setFilteredUsers(filtered);
    }
  };

  useEffect(() => {
    if (selectedModule === "collection") {
      const options = [
        { value: "all", label: getTranslation("all") },
        ...collections.map((col) => ({
          value: col.collectionId,
          label: col.collectionTitle,
        })),
      ];
      setSubModuleOptions(options);
      setSelectedSubModule("all");
    } else if (selectedModule === "task-managment") {
      const options = [
        { value: "all", label: getTranslation("all") },
        ...panels.map((panel) => ({
          value: panel.panelId,
          label: panel.panelTitle,
        })),
      ];
      setSubModuleOptions(options);
      setSelectedSubModule("all");
    } else {
      setSubModuleOptions([]);
      setSelectedSubModule("");
    }
  }, [selectedModule, collections, panels, getTranslation]);

  return (
    <div className="projects-auth">
      <p className="invite-collaborators-title">
        {getTranslation("authorization")}
      </p>
      <div className="select-search-container">
        <UserSearchInput
          placeholder={getTranslation("search")}
          onSearch={handleSearch}
        />
      </div>
      <ProjectUserTable users={filteredUsers} onPermissionChange={handlePermissionChange} />
    </div>
  );
};

export default ProjectAuthorization;
